import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentTrack: null,
  currentTopic: null,
  currentMake: null,
  currentComponents: null,
  currentIndex: null,
  space: null,
};

const appState = (state) => {
  return {
    tracks: state.app.tracks,
    track: state.app.currentTrack,
    topic: state.app.currentTopic,
    make: state.app.currentMake,
    components: state.app.currentComponents,
    currentIndex: state.app.currentIndex,
    space: state.app.space,
  };
};
export const getAppData = createSelector(appState, (appState) => appState);

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSpace: (state, action) => {
      state.space = action.payload;
    },
    setCurrentTrack: (state, action) => {
      state.currentTrack = action.payload;
    },
    setCurrentMake: (state, action) => {
      state.currentMake = action.payload;
    },
    setCurrentTopic: (state, action) => {
      state.currentTopic = action.payload;
    },
    setComponents: (state, action) => {
      state.currentComponents = action.payload;
    },
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
    resetStatesBesideTrack: (state) => {
      state.currentIndex = null;
      state.currentMake = null;
      state.currentTopic = null;
    },
    resetAppSlice: (state) => {
      state.currentTrack = null;
      state.currentTopic = null;
      state.currentMake = null;
      state.currentComponents = null;
      state.currentIndex = null;
      state.space = null;
    },
  },
});

export const {
  resetStatesBesideTrack,
  setCurrentTrack,
  setCurrentMake,
  setCurrentTopic,
  setComponents,
  setCurrentIndex,
  resetAppSlice,
  setSpace,
} = appSlice.actions;

export default appSlice.reducer;
